import { render, staticRenderFns } from "./CartoesMercadoPago.vue?vue&type=template&id=f72f9202&scoped=true"
import script from "./CartoesMercadoPago.vue?vue&type=script&lang=js"
export * from "./CartoesMercadoPago.vue?vue&type=script&lang=js"
import style0 from "./CartoesMercadoPago.vue?vue&type=style&index=0&id=f72f9202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72f9202",
  null
  
)

export default component.exports